export default class Template {
  constructor(API) {
    this.api = API;
  }
  /*
  {
    courseID: 'validString',
    name: 'validString',
    internalName: 'validString',
    releaseType: 'validString',
    capacity: 'number',
    reservedCapacity: 'optionalNumber',
    minCapacity: 'validString',
    notificationDetails: 'any',
    internalNotes: 'optionalValidString',
    requiresInstructor: 'boolean?',
    requiresAdminReview: 'boolean?',
    askForReferrals: 'boolean?',
    hasMaterial: 'validString',
    content: 'any?',
    isPrivate: 'boolean',
    duration: 'number',
    venueID: 'validString',
    venueComplement: 'validString',
    considerFailues: 'boolean?',
    onlineAccessPeriod: 'optionalNumber',
    providerCourseTemplateID: 'validString',
    accessLink: 'validString',
    courseProviderID: 'validString',
    //add
    tenantID: 'validString',
    type: 'string',
  }
  */
  async createTemplate(templateObj) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/template/new';
    req.body = templateObj;
    return await req.exec();
  }
  async updateTemplate(templatedID, templateObj) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = '/template/' + templatedID;
    req.body = templateObj;
    return await req.exec();
  }
  async deleteTemplate(templateID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = '/template/' + templateID;
    return await req.exec();
  }
  async getTemplate(templateID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/template/' + templateID;
    return await req.exec();
  }
  async getTemplates() {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/templates/';
    return await req.exec();
  }
}
